import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, computed, inject, OnDestroy, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthApiService } from '@p2p/auth/api';
import { UserRole } from '@p2p/users/domain';
import { filter, map } from 'rxjs';

import { RouteDataService } from './services/route-data.service';

const authorizationRoute = '/authorization';
const mobileMarkupAccountsRoles = [UserRole.Trader, UserRole.Operator, UserRole.TeamLead];

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly routeDataService = inject(RouteDataService);
    private readonly authApiService = inject(AuthApiService);

    account = toSignal(this.authApiService.account$);

    isHeaderHidden = toSignal(this.routeDataService.hideHeader$);
    isSideMenuHidden = toSignal(this.routeDataService.hideSideMenu$);
    isDesktopMinWidth = signal(true);
    isAccountMobileMarkup = computed(() => mobileMarkupAccountsRoles.includes(this.account()?.role));

    ngOnInit() {
        this.routeDataService.init(this.route, this.router);
        this.authApiService.checkAuthentication();

        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            this.isDesktopMinWidth.set(!this.router.url.startsWith(authorizationRoute));
        });
    }

    ngOnDestroy() {
        this.routeDataService.destroy();
    }
}
